module.exports = __webpack_public_path__ + "img/members-directory.8bfffde8.png";